(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.quantity-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('.quantity-selector__input');
        var value = parseInt(input.value, 10) || 0;
        var min = parseInt(input.min, 10) || 0;

        if (this.dataset.action === 'decrease') {
          input.value = Math.max(min, value - 1);
        } else {
          input.value = value + 1;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        window.location.href = this.value;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var tabs = document.querySelectorAll('.featured-products__tab');
    var panels = document.querySelectorAll('.featured-products__panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = this.dataset.tabIndex;

        tabs.forEach(function(t) {
          t.classList.remove('featured-products__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(p) {
          p.classList.remove('featured-products__panel--active');
        });

        this.classList.add('featured-products__tab--active');
        this.setAttribute('aria-selected', 'true');

        var target = document.querySelector('.featured-products__panel[data-tab-index="' + index + '"]');
        if (target) {
          target.classList.add('featured-products__panel--active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* Quantity selector */
    document.querySelectorAll('.quantity-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('.quantity-selector__input');
        var value = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;

        if (this.dataset.action === 'decrease') {
          input.value = Math.max(min, value - 1);
        } else {
          input.value = value + 1;
        }
      });
    });

    /* Thumbnail gallery */
    var mainImage = document.getElementById('product-main-image');
    if (mainImage) {
      document.querySelectorAll('.product-page__thumbnail').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var img = mainImage.querySelector('img');
          if (img) {
            img.src = this.dataset.imageUrl;
            img.alt = this.dataset.imageAlt || '';
          }
          document.querySelectorAll('.product-page__thumbnail').forEach(function(t) {
            t.classList.remove('product-page__thumbnail--active');
          });
          this.classList.add('product-page__thumbnail--active');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veg-box"]) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-veg-box]');
    if (!root) return;

    var form = root.querySelector('[data-veg-box-form]');
    var config = root.querySelector('.veg-box__config');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-veg-box-item]'));
    var extras = Array.prototype.slice.call(root.querySelectorAll('[data-veg-box-extra]'));
    var quantityInput = root.querySelector('[data-veg-box-quantity]');
    var contentsList = root.querySelector('[data-veg-box-contents]');
    var changesLine = root.querySelector('[data-veg-box-changes]');
    var extrasLabel = root.querySelector('[data-veg-box-extras-label]');
    var errorEl = root.querySelector('[data-veg-box-error]');
    var submit = root.querySelector('[data-veg-box-submit]');
    var msg = config.dataset;
    var maxChanges = parseInt(msg.maxChanges, 10) || 0;
    var boxPrice = parseInt(msg.boxPrice, 10) || 0;
    var soldOut = submit.disabled;
    var formatter;

    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: msg.currency
      });
    } catch (e) {
      formatter = { format: function(n) { return n.toFixed(2); } };
    }

    function money(cents) {
      return formatter.format(cents / 100);
    }

    function qty(input) {
      return Math.max(0, parseInt(input.value, 10) || 0);
    }

    function checkedChoice(item) {
      return item.querySelector('.veg-box-item__options input:checked');
    }

    /* choice is 'keep', 'out' or the variant id of the swap */
    function itemState(item) {
      var input = checkedChoice(item);
      var choice = input ? input.value : 'keep';
      var swapping = choice !== 'keep' && choice !== 'out';
      return {
        title: item.dataset.title,
        kept: choice !== 'out',
        swapTitle: swapping ? input.dataset.title : null
      };
    }

    function countChanges() {
      return items.reduce(function(total, item) {
        var s = itemState(item);
        return total + (!s.kept || s.swapTitle ? 1 : 0);
      }, 0);
    }

    function showError(text) {
      errorEl.textContent = text;
      errorEl.hidden = !text;
    }

    /* Final contents as [{ name, count }] in order of first appearance. */
    function contentsEntries() {
      var order = [];
      var counts = {};
      items.forEach(function(item) {
        var s = itemState(item);
        var name = s.swapTitle || (s.kept ? s.title : null);
        if (!name) return;
        if (!counts[name]) { counts[name] = 0; order.push(name); }
        counts[name] += 1;
      });
      return order.map(function(name) {
        return counts[name] > 1 ? name + ' ×' + counts[name] : name;
      });
    }

    /* Every standard item with what happens to it, e.g.
       "Carrots 2kg, Beets 500g (left out), Kale → Neep". The packing slip
       (docs/packing-slip.liquid) parses the " → " and "(left out)" markers. */
    function packingList() {
      return items.map(function(item) {
        var s = itemState(item);
        if (!s.kept) return msg.msgPackingLeftOut.replace('%item%', s.title);
        if (s.swapTitle) return s.title + ' → ' + s.swapTitle;
        return s.title;
      }).join(', ');
    }

    /* e.g. "Leave out: Beets, Kale · Carrots → Neep", or '' when unchanged */
    function changesText() {
      var left = [];
      var swaps = [];
      items.forEach(function(item) {
        var s = itemState(item);
        if (!s.kept) left.push(s.title);
        else if (s.swapTitle) swaps.push(s.title + ' → ' + s.swapTitle);
      });
      var parts = [];
      if (left.length) parts.push(msg.msgLeaveOut + ': ' + left.join(', '));
      return parts.concat(swaps).join(' · ');
    }

    function extrasLines() {
      return extras.map(function(row) {
        var input = row.querySelector('.quantity-selector__input');
        return {
          id: parseInt(row.dataset.variantId, 10),
          quantity: input ? qty(input) : 0,
          price: parseInt(row.dataset.price, 10) || 0
        };
      }).filter(function(line) { return line.quantity > 0; });
    }

    function setOpen(item, open) {
      var toggle = item.querySelector('[data-veg-box-toggle]');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.querySelector('.veg-box-item__options').hidden = !open;
    }

    function render() {
      items.forEach(function(item) {
        var s = itemState(item);
        var status = item.querySelector('[data-veg-box-status]');
        item.classList.toggle('veg-box-item--out', !s.kept);
        status.textContent = !s.kept ? msg.msgLeftOut : s.swapTitle ? '→ ' + s.swapTitle : '';
      });

      contentsList.textContent = '';
      contentsEntries().forEach(function(name) {
        var li = document.createElement('li');
        li.textContent = name;
        contentsList.appendChild(li);
      });

      var changes = changesText();
      changesLine.textContent = changes ? msg.msgChangesLine.replace('%changes%', changes) : '';
      changesLine.hidden = !changes;

      extras.forEach(function(row) {
        var input = row.querySelector('.quantity-selector__input');
        row.classList.toggle('veg-box-extra--added', !!input && qty(input) > 0);
      });

      var lines = extrasLines();
      var extrasCount = 0;
      var extrasTotal = 0;
      lines.forEach(function(line) {
        extrasCount += line.quantity;
        extrasTotal += line.price * line.quantity;
      });
      if (extrasLabel) {
        extrasLabel.textContent = !extrasCount ? msg.msgExtras
          : (extrasCount === 1 ? msg.msgExtrasOne : msg.msgExtrasOther)
            .replace('%count%', extrasCount)
            .replace('%total%', money(extrasTotal));
      }

      if (!soldOut && !submit.dataset.busy) {
        var boxes = Math.max(1, qty(quantityInput));
        submit.textContent = msg.msgAddTotal.replace('%total%', money(boxPrice * boxes + extrasTotal));
      }
    }

    items.forEach(function(item) {
      var toggle = item.querySelector('[data-veg-box-toggle]');

      /* Only one item's options are open at a time. */
      toggle.addEventListener('click', function() {
        var opening = toggle.getAttribute('aria-expanded') !== 'true';
        items.forEach(function(other) { setOpen(other, false); });
        setOpen(item, opening);
      });

      /* Enforce max_changes by restoring the previous choice. */
      item.querySelectorAll('.veg-box-item__options input').forEach(function(input) {
        input.addEventListener('change', function() {
          if (maxChanges && countChanges() > maxChanges) {
            var previous = item.querySelector('.veg-box-item__options input[value="' + item.dataset.current + '"]');
            if (previous) previous.checked = true;
            showError(msg.msgMax);
          } else {
            item.dataset.current = input.value;
            showError('');
            setOpen(item, false);
            toggle.focus();
          }
          render();
        });
      });
    });

    root.querySelector('[data-veg-box-reset]').addEventListener('click', function() {
      items.forEach(function(item) {
        item.querySelector('.veg-box-item__options input[value="keep"]').checked = true;
        item.dataset.current = 'keep';
        setOpen(item, false);
      });
      showError('');
      render();
    });

    extras.forEach(function(row) {
      var add = row.querySelector('[data-veg-box-extra-add]');
      if (!add) return;
      add.addEventListener('click', function() {
        row.querySelector('.quantity-selector__input').value = 1;
        render();
        row.querySelector('[data-action="increase"]').focus();
      });
    });

    /* Steppers (extras may go down to 0, the box quantity to 1) */
    root.querySelectorAll('.quantity-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('.quantity-selector__input');
        var min = parseInt(input.min, 10) || 0;
        var value = parseInt(input.value, 10) || 0;
        input.value = this.dataset.action === 'decrease' ? Math.max(min, value - 1) : value + 1;
        render();
        var row = this.closest('[data-veg-box-extra]');
        if (row && qty(input) === 0) row.querySelector('[data-veg-box-extra-add]').focus();
      });
    });
    root.querySelectorAll('.quantity-selector__input').forEach(function(input) {
      input.addEventListener('input', render);
    });

    function setBusy(busy) {
      submit.disabled = busy;
      if (busy) {
        submit.dataset.busy = 'true';
        submit.textContent = msg.msgAdding;
      } else {
        delete submit.dataset.busy;
        render();
      }
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      if (submit.disabled) return;
      showError('');

      if (maxChanges && countChanges() > maxChanges) {
        showError(msg.msgMax);
        return;
      }

      if (!contentsEntries().length && !window.confirm(msg.msgEmpty)) return;

      var properties = {};
      properties[msg.msgContents] = packingList();
      properties[msg.msgChanges] = changesText() || msg.msgNone;

      var lines = [{
        id: parseInt(msg.boxVariantId, 10),
        quantity: Math.max(1, qty(quantityInput)),
        properties: properties
      }];
      extrasLines().forEach(function(line) {
        lines.push({ id: line.id, quantity: line.quantity });
      });

      setBusy(true);

      fetch(msg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines })
      }).then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(data) {
          if (!response.ok) throw new Error(data.description || data.message || msg.msgError);
          window.location.href = msg.cartUrl;
        });
      }).catch(function(error) {
        showError(error && error.message ? error.message : msg.msgError);
        setBusy(false);
      });
    });

    /* Back navigation can restore the page from bfcache with the button still disabled. */
    window.addEventListener('pageshow', function(event) {
      if (event.persisted && !soldOut) setBusy(false);
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
